import React from 'react';
// Make logger available globally for debugging
import logger from './logger';

/* Convert value to float */
export const float = (number) => number ? parseFloat(number) : '';

/* Format Numbers with commas by the thousand */
export const numberWithCommas = (number, decimal = 0) => number ? float(float(number).toFixed(decimal)).toLocaleString('en') : 0;

/* Un-Format Numbers with commas to remove commas */
export const parseNumberWithCommas = (number) => number ? float(number.replace(/,/g, '')) : 0;

/* Calculate Percent with optional decimal */
export const percent = (value, total, decimal = 0) => value && total ? ((float(value) / float(total)) * 100).toFixed(decimal) : 0;

/* Format a Range */
export const range = (low, high) => low && high ? <span>{low}&nbsp;&#8209;&nbsp;{high}</span> : '';

export const formatPhoneNumber = (string) => {
    if (string) {
        const stringFormatted = string.toString().replace(/\D/g, '');
        const m = stringFormatted.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!m) ? null : '(' + m[1] + ') ' + m[2] + '-' + m[3];
    } else {
        return '';
    }
};

/* Strip out HTML and return string */
export const stripHTML = (html) => {
    const temp = document.createElement('div');
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || '';
};

/* Safely merge query params into a URL, preserving any params already on it.
 * Empty/null/undefined values are skipped. Returns the original string if it
 * can't be parsed as a URL. */
export const appendQueryParams = (url, params = {}) => {
    if (!url) {
        return url;
    }
    try {
        // Provide a base so relative URLs still parse; absolute URLs ignore it.
        const parsed = new URL(url, window.location.origin);
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                parsed.searchParams.set(key, value);
            }
        });
        return parsed.toString();
    } catch (error) {
        logger.warn('appendQueryParams: failed to parse URL, returning original', { url, error: error.message });
        return url;
    }
};

/* Import and re-export logger for easy access */
export { default as logger } from './logger';

if (typeof window !== 'undefined') {
    window.logger = logger;
}
